import { Container, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import Carousel from './Carousel';

const usestyles = makeStyles(()=>({
    banner:{
        backgroundImage: "url(./banner2.avif)",
        backgroundSize:"contain"
    },
    bannerContent:{
        height:400,
        display:"flex",
        flexDirection:"column",
        paddingTop:25,
        justifyContent:"space-around"
    },
    tagline:{
        display:"flex",
        height:"40%",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center"
    }
}))

function Banner() {

    const classes = usestyles();

  return (
    <div className={classes.banner}>
        <Container className={classes.bannerContent}>
            <div className={classes.tagline}>
                <Typography variant='h2' 
                style={{
                    fontWeight:"bold",
                    marginBottom: 15,
                    fontFamily:"Montserrat"
                }}>
                    Crypto Vortex
                </Typography>
                <Typography variant='subtitle2' 
                    style={{
                        color:"darkgrey",
                        textTransform:"capitalize",
                        fontFamily:"Montserrat"
                    }}
                >
                Empowering You with Insights on Every Cryptocurrency: Navigate the World of Digital Currency with Ease!
                </Typography>
            </div>
            <Carousel/>
        </Container>
    </div>
  )
}

export default Banner